module.exports = __webpack_public_path__ + "static/media/Zamzama c. 1970s.403e4879.jpg";